import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';

export const exportColumns = (t) => {
  return [
    // { fieldName: "id", fieldTitle: "Id", fieldType: "TEXT" },
    { fieldName: 'id', fieldTitle: 'ID', fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Απόβλητο'), fieldType: 'TEXT' },
    { fieldName: 'ekaCodeValues', fieldTitle: t('Κωδικοί ΕΚΑ'), fieldType: 'TEXT' },
    { fieldName: 'unClassValues', fieldTitle: t('Κλάσεις UN'), fieldType: 'TEXT' },
    { fieldName: 'notes', fieldTitle: t('Παρατηρήσεις'), fieldType: 'TEXT' },
    { fieldName: 'defEkaCode', fieldTitle: t('Προεπιλεγμένος Κωδ. ΕΚΑ'), fieldType: 'TEXT' },
    { fieldName: 'defUnClass', fieldTitle: t('Προεπιλεγμένη Κλάση UN'), fieldType: 'TEXT' },
    { fieldName: 'isHazardous', fieldTitle: t('Επικίνδυνο Απόβλητο'), fieldType: 'TEXT' },
    { fieldName: 'useInProduction', fieldTitle: t('Χρήση στην Παραγωγή'), fieldType: 'TEXT' },
    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },
    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getMaterials.data.map((values) => {
        console.log("values", values);
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
            }  - ${values.firstUser}`,
          lastRec: ` ${values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
            }  - ${values.lastUser}`,
        };
      });
      const trsData = {
        getMaterials: { data: recs, recordCount: data?.getMaterials?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Materials',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
